// ErrorPage.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Container, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ErrorPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Container
      maxWidth="md"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: isMobile ? 2 : 4,
      }}
    >
      <Typography variant={isMobile ? 'h4' : 'h1'}>{t('error.pageGetError')}</Typography>
      <Grid container justifyContent="center" alignItems="center" sx={{ padding: isMobile ? '1rem' : '2rem' }}>
        <Button variant="contained" color="primary" onClick={handleGoHome}>
          请点击以回到首页
        </Button>
      </Grid>
    </Container>
  );
};

export default ErrorPage;